import { useTrackingUtils } from '../utils/useTrackingUtils'

export const usePageTracking = () => {
  const { wrapLocale } = useRoutesUtils()
  const { trackEvent } = useTrackingUtils()
  const store = useRoutesStore()
  const route = useRoute()

  /**
   * trackPage,
   * handles all tracking events on page load
   */
  async function trackPage(locale: string) {
    await store.retrieveRoutes()
    const { getRouteByPath } = useRoutes(store.routes, wrapLocale(locale))

    // Skip tracking if not running in the client

    const routeData = getRouteByPath(route?.path)

    const [lang, region] = locale?.split('_') || []
    const eventData = {
      event: 'virtual_page',
      page: {
        group: routeData?.payload?.category,
        type: routeData?.payload?.subcategory,
        path: routeData?.payload?.defaultLocaleRoute,
        locale_path: routeData?.route,
        full_url: window?.location.href,
        first_publish_date: routeData?.payload?.firstPublishedAt,
        publish_date_epoch: routeData?.payload?.firstPublishedAt
          ? Math.floor(new Date(routeData?.payload?.firstPublishedAt).getTime() / 1000)
          : null
      },
      site: {
        lang,
        region
      }
    }

    trackEvent(eventData)
  }

  return {
    trackPage
  }
}
